import {Component} from '@angular/core';
import {BaseFieldType} from 'compob2b-libs';
import {FormlyValidationMessage} from '@ngx-formly/core'
import {NgIf} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {TuiTextfield} from '@taiga-ui/core'
import {TuiInputColor, tuiInputColorOptionsProvider} from '@taiga-ui/kit'

@Component({
  templateUrl: './color-picker.component.html',
  imports: [
    FormlyValidationMessage,
    NgIf,
    ReactiveFormsModule,
    TuiTextfield,
    TuiInputColor,
    FormsModule
  ],
  providers: [tuiInputColorOptionsProvider({format: 'hex', align: 'right'})],
})
export class ColorPickerComponent extends BaseFieldType {
  get value() {
    return this.model.color;
  }

  set value(value) {
    this.model.color = value;
  }

}
